var _StyledArrow;

var _excluded = ["design"],
    _excluded2 = ["value", "placeholder", "hasItems"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { body1, accent, primary, secondary, tertiary, success, warning, critical, applyEllipsis } from '@salutejs/plasma-core';
import { IconChevronDown } from '@salutejs/plasma-icons';
import { inputBorder, inputBorderHover } from '../../tokens';
import { applyB2CSelectButton } from './views/b2c/SelectButton';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Select/SelectButton');
var statuses = {
  success: success,
  warning: warning,
  error: critical
};
var StyledArrow = /*#__PURE__*/styled(IconChevronDown).withConfig({
  componentId: "plasma-web-core__sc-wqinip-0"
})(["margin:var(--plasma-select-button-arrow-margin,0 0 0 0.75rem);transition:color 0.3s ease-in-out,transform 0.15s ease-in-out;pointer-events:none;user-select:none;"]);
var StyledText = /*#__PURE__*/styled.span.withConfig({
  componentId: "plasma-web-core__sc-wqinip-1"
})(["", ";color:", ";transition:color 0.3s ease-in-out;pointer-events:none;user-select:none;"], applyEllipsis, primary);
var StyledPlaceholder = /*#__PURE__*/styled.span.withConfig({
  componentId: "plasma-web-core__sc-wqinip-2"
})(["", ";color:", ";pointer-events:none;user-select:none;"], applyEllipsis, tertiary);
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "plasma-web-core__sc-wqinip-3"
})(["", ";display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;width:100%;height:3rem;padding:0.875rem 0.9375rem;border:1px solid ", ";border-radius:0.25rem;background-color:transparent;color:", ";transition:border-color 0.3s ease-in-out;", " &:disabled{cursor:inherit;}&:not(:disabled):focus{outline:0 none;border-color:", ";color:", ";}", " ", " ", " ", ""], body1, inputBorder, secondary, function (_ref) {
  var hasItems = _ref.hasItems;
  return hasItems && css(["&:not(:disabled):hover{cursor:pointer;border-color:", ";color:", ";}"], inputBorderHover, secondary);
}, accent, accent, function (_ref2) {
  var focused = _ref2.focused;
  return focused && css(["border-color:", ";color:", ";"], accent, accent);
}, function (_ref3) {
  var status = _ref3.status;
  return status && css(["border-color:", ";color:", ";&:hover,&:focus{border-color:", ";}"], statuses[status], statuses[status], statuses[status]);
}, function (_ref4) {
  var isOpen = _ref4.isOpen;
  return isOpen && css(["", "{transform:rotate(-180deg);}"], StyledArrow);
}, function (_ref5) {
  var design = _ref5.design,
      props = _objectWithoutProperties(_ref5, _excluded);

  return design === 'b2c' && applyB2CSelectButton(props);
}); // eslint-disable-next-line prefer-arrow-callback

export var SelectButton = /*#__PURE__*/forwardRef(function SelectButton(_ref6, ref) {
  var value = _ref6.value,
      placeholder = _ref6.placeholder,
      hasItems = _ref6.hasItems,
      rest = _objectWithoutProperties(_ref6, _excluded2);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    type: "button"
  }, rest, {
    ref: ref,
    hasItems: hasItems,
    "aria-label": placeholder
  }), value && /*#__PURE__*/React.createElement(StyledText, null, value), placeholder && !value && /*#__PURE__*/React.createElement(StyledPlaceholder, {
    "aria-hidden": "true"
  }, placeholder), hasItems && (_StyledArrow || (_StyledArrow = /*#__PURE__*/React.createElement(StyledArrow, {
    size: "xs",
    color: "inherit"
  }))));
});